// routes/ProtectedRoute.js

import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ roles, userRole, children }) {
  if (!roles || roles.length === 0) return children;

  return roles.includes(userRole)
    ? children
    : <Navigate to="/HomePage" />;
}
